export default __webpack_public_path__ + "static/media/students-icon.c1318733.svg";